import type { Featherico } from 'featherico';
import { IconChevronDown, IconChevronLeft, IconChevronRight, IconChevronUp } from 'featherico';
import type { ComponentType } from 'react';

type Direction = 'UP' | 'DOWN' | 'LEFT' | 'RIGHT';

type Props = {
    dir?: Direction;
    className?: string;
    resetMargin?: boolean;
};

const DIRECTION: Record<Direction, ComponentType<Featherico>> = {
    UP: IconChevronUp,
    DOWN: IconChevronDown,
    LEFT: IconChevronLeft,
    RIGHT: IconChevronRight,
};

export default function Arrow({ className, dir = 'DOWN', resetMargin }: Props) {
    const Icon = DIRECTION[dir];
    return <Icon className={className} style={resetMargin ? { margin: 0 } : undefined} />;
}
